import React, { useState, useEffect } from "react";
import { useEmblaCarousel } from "embla-carousel/react";
import Slider from "react-slick";

import { ArrowIcon, BackArrowIcon } from "./icons";

const SliderImage = ({ asset }) => {
  const [isLoading, setIsLoading] = useState(true);

  const imgOnload = () => {
    setIsLoading(false);
  };

  return (
    <div
      className={`product__slider-imagewrap product__slider-imagewrap--loading-${isLoading}`}
    >
      <canvas
        className={`product__slider-loader product__slider-loader--loading-${isLoading}`}
        style={{ backgroundImage: `url(${asset.loader})` }}
        width={`${asset.width}`}
        height={`${asset.height}`}
      ></canvas>
      <img
        className={`product__slider-img product__slider-img--loading-${isLoading}`}
        onLoad={() => imgOnload()}
        srcSet={asset.srcset}
        alt={asset.alt}
      />
    </div>
  );
};

const ProductSlider = ({
  productSliderAssets,
  currentVariant,
  productObject,
}) => {
  const isGiftCard = productObject.type.toLowerCase().includes("gift card");
  const isSingleSlider =
    isGiftCard ||
    productObject.tags.filter((tag) => tag.includes("single-slider")).length >
      0;

  // TODO: REMOVE DUAL OPTION IF WE WONT RETURN TO USING THIS IDEA - ask about
  const isDualSlider =
    productObject.tags.filter((tag) => tag.includes("dual-slider")).length > 0;

  const sliderOptions = { loop: true };
  const [emblaRef, emblaApi] = useEmblaCarousel(sliderOptions);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", () =>
      setCurrentSlideIndex(emblaApi.selectedScrollSnap())
    );
    emblaApi.on("reInit", () =>
      setCurrentSlideIndex(emblaApi.selectedScrollSnap())
    );
    emblaApi.on("init", () => setCurrentSlideIndex(0));
  }, [emblaApi]);

  const [currentSliderAssets, setCurrentSliderAssets] =
    useState(productSliderAssets);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [hasSlider, setHasSlider] = useState(true);
  const typeVariantHandle = {
    old: "products",
    new: "files",
  };

  useEffect(() => {
    if (!isSingleSlider) {
      if (currentVariant.featured_image) {
        let cvHandle = currentVariant?.featured_image?.src
          .split("?")[0]
          .toLowerCase();

        // validate if image url contains /products or /files
        if (
          currentVariant.featured_image.src
            .split("?")[0]
            .includes(typeVariantHandle.new)
        ) {
          cvHandle = cvHandle.split("files/")[1].split(".")[0];
        } else {
          cvHandle = cvHandle.split("products/")[1].split(".")[0];
        }

        cvHandle = cvHandle.replace(/-?[0-9]?[0-9]/g, "");
        cvHandle = cvHandle.split("_emb")[0].split("_")[0];
        cvHandle = cvHandle.replace(".jpg", "");

        const currentAssets = productSliderAssets.filter((asset) => {
          if (asset.imageBase.toLowerCase().includes("_emb")) return false;

          if (asset.imageBase.includes("_")) {
            return (
              asset.imageBase
                .toLowerCase()
                .split("_")[0]
                .replace(/[0-9]/g, "weezie-asset")
                .replace(".jpg", "") ===
              cvHandle + "-weezie-asset"
            );
          } else {
            return (
              asset.imageBase
                .toLowerCase()
                .replace(/[0-9]/g, "weezie-asset")
                .replace(".jpg", "") ===
              cvHandle + "-weezie-asset"
            );
          }
        });
        setCurrentSliderAssets(currentAssets);
      } else {
        setCurrentSliderAssets([]);
      }
    }
  }, [currentVariant]);

  useEffect(() => {
    if (currentSliderAssets.length > 1) {
      setHasSlider(true);
      if (emblaApi) {
        // when switching to a new variant:
        emblaApi.reInit(sliderOptions);
        emblaApi.scrollTo(0, true);
      }
    } else {
      setHasSlider(false);
    }
  }, [currentSliderAssets]);

  const thumbClick = (i) => {
    emblaApi.scrollTo(i);
  };
  const PrevArrow = (props) => (
    <div className="slick-arrow slick-arrow__prev" onClick={props.onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
      >
        <g opacity="0.6">
          <path
            d="M28 14L18 24L28 34"
            stroke="#EAD0B6"
            strokeWidth="2.0625"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </div>
  );

  const NextArrow = (props) => (
    <div className="slick-arrow slick-arrow__next" onClick={props.onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
      </svg>
    </div>
  );
  const NextArrowMobile = (props) => (
    <div className="slick-arrow slick-arrow__next" onClick={props.onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-chevron-right"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
        />
      </svg>
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    speed: 500,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    btl: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          rtl: false,
          nextArrow: <NextArrowMobile />,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* plain asset - no slider */}
      {!hasSlider && currentSliderAssets[0] && (
        <div className={`product__slider`}>
          <div className="product__slider-inner">
            <SliderImage asset={currentSliderAssets[0]} />
          </div>
        </div>
      )}

      {/* slider */}
      {hasSlider && currentSliderAssets[0] && (
        <>
          <div className="product__slider-frame">
            <div
              onClick={() => emblaApi.scrollPrev()}
              className="product__slider-arrow product__slider-arrow--prev"
            >
              <BackArrowIcon />
            </div>

            <div
              onClick={() => emblaApi.scrollNext()}
              className="product__slider-arrow product__slider-arrow--next"
            >
              <ArrowIcon />
            </div>

            <div className={`embla product__slider`} ref={emblaRef}>
              <div className="embla__container product__slider-container">
                {currentSliderAssets.map((image) => (
                  <div
                    key={image.imageBase}
                    className="embla__slide product__slider-slide"
                  >
                    <div className="product__slider-inner">
                      <SliderImage asset={image} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="product__slider-controls">
            <div className="product__slider-wrapper">
              {currentSliderAssets.length > 5 ? (
                <Slider {...settings}>
                  {" "}
                  {currentSliderAssets.map((image, i) => (
                    <div
                      key={image.src}
                      className="product__slider-controls-btn-wrapper"
                    >
                      <div
                        onClick={() => thumbClick(i)}
                        className={`product__slider-controls-btn${
                          currentSlideIndex === i
                            ? " product__slider-controls-btn--active"
                            : ""
                        }`}
                      >
                        <img
                          srcSet={image.thumbSrcset}
                          src={image.thumbSrc}
                          alt={image.alt}
                        />
                      </div>
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="product__slider-inactive">
                  {currentSliderAssets.map((image, i) => (
                    <div
                      key={image.src}
                      className="product__slider-controls-btn-wrapper"
                    >
                      <div
                        onClick={() => thumbClick(i)}
                        className={`product__slider-controls-btn${
                          currentSlideIndex === i
                            ? " product__slider-controls-btn--active"
                            : ""
                        }`}
                      >
                        <img
                          srcSet={image.thumbSrcset}
                          src={image.thumbSrc}
                          alt={image.alt}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductSlider;
